import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';

import viewerStyles from '../../../Viewer/presets/UserAbout/UserAbout.scss';
import s from './UserAbout.scss';

const UserAboutEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <>
      <Editor
        {...props}
        withinModal
        presetId="userabout"
        className={cn(s['root'], viewerStyles['root'])}
        extensionConfig={extConfig}
      ></Editor>
    </>
  );
};
UserAboutEditor.displayName = 'UserAboutEditor';

export default UserAboutEditor;
